import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ListDokumen, RiplayUmumModel, RiplayUmumRequest} from "./riplay-umum.model";
import {Observable} from "rxjs";
import {HttpEformService} from "../../global/HttpEformService";

@Injectable({
  providedIn: 'root'
})
export class RiplayUmumService extends HttpEformService {


  featureUrl = this.url + "riplay-umum"

  constructor(protected override http: HttpClient) {
    super(http)
  }

  getRiplay(request: RiplayUmumRequest): Observable<RiplayUmumModel[]> {
    return this.http
      .post<RiplayUmumModel[]>(this.featureUrl, request);
  }

  getDokumen(request: string): Observable<ListDokumen> {
    let url = "https://cmis.azlife.allianz.co.id/services/dmsrs/search/?q=select * from CreditLifeDocument where ReferenceNumber = '" + request + "'"
    console.log(url)
    return this.http
      .get<ListDokumen>(url);
  }
}
